import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Typography from '../typography';
import Flex from '@components/layout/flex';
import DefaultAvatar from '@components/basics/default-avatar';

interface UserAvatarInfoProps {
  className?: string;
  src?: string;
  name: string;
}

const UserAvatarInfo: FunctionComponent<UserAvatarInfoProps> = ({
  className,
  src,
  name,
}) => {
  return (
    <Flex className={className || ''} gap={10} alignItems="center">
      {src ? <CircleAvatar src={src} alt={name} /> : <StyledDefaultAvatar />}
      <div>
        <Typography weight="700">{name}</Typography>
      </div>
    </Flex>
  );
};

export default UserAvatarInfo;

const CircleAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const StyledDefaultAvatar = styled(DefaultAvatar)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
`;
